/**
 * @generated SignedSource<<737246148ac077f0581922eb10703f08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type SitesFilterInput = {
  isActive?: ActiveRecords | null | undefined;
  schoolYearEndsBeforeOrOn?: any | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  userId?: string | null | undefined;
};
export type SitesTargetGroupsQuery$variables = {
  sitesFilter?: SitesFilterInput | null | undefined;
  skip?: boolean | null | undefined;
};
export type SitesTargetGroupsQuery$data = {
  readonly sites?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
      readonly name: string | null | undefined;
      readonly summary: string | null | undefined;
      readonly targetGroups: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SitesTargetGroupsQuery = {
  response: SitesTargetGroupsQuery$data;
  variables: SitesTargetGroupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sitesFilter"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 100
          },
          {
            "kind": "Variable",
            "name": "sitesFilterInput",
            "variableName": "sitesFilter"
          }
        ],
        "concreteType": "SiteNodeConnection",
        "kind": "LinkedField",
        "name": "sites",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SiteNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetGroupNode",
                "kind": "LinkedField",
                "name": "targetGroups",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SitesTargetGroupsQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SitesTargetGroupsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2469e748945a1d93381c408932099e21",
    "id": null,
    "metadata": {},
    "name": "SitesTargetGroupsQuery",
    "operationKind": "query",
    "text": "query SitesTargetGroupsQuery(\n  $sitesFilter: SitesFilterInput\n  $skip: Boolean = false\n) {\n  sites(sitesFilterInput: $sitesFilter, first: 100) @skip(if: $skip) {\n    nodes {\n      id\n      summary\n      name\n      isActive\n      targetGroups {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "18ec3c07939b07c8ac2b89d6dd01bf45";

export default node;
